import React, { useState } from 'react'
import { useServices, useTranslation } from 'cng-web-lib'
import Namespace from '../../../../constants/locale/Namespace'
import SbciInvoiceKeys from '../../../../constants/locale/key/SbciInvoice'
import SbciInvoiceApiUrls from '../../../../apiUrls/SbciInvoiceApiUrls'
import CngSection from '../../../../components/cngcomponents/CngSection'
import { Grid } from '@material-ui/core'
import { format } from 'date-fns'
import QuickExportButton from '../QuickExportButton'

function AdditionalFormInfoSection(props) {
  const { invoiceData, showNotification } = props

  const [download, setDownload] = useState({ form: null, loading: false })
  const { securedSendRequest } = useServices()
  const { translate } = useTranslation(Namespace.SBCI_INVOICE)
  const translatedTextsObject = makeTranslatedTextsObject()

  function makeTranslatedTextsObject() {
    let bolForm = translate(
      Namespace.SBCI_INVOICE,
      SbciInvoiceKeys.BolForm.TITLE
    )
    let tscaForm = translate(
      Namespace.SBCI_INVOICE,
      SbciInvoiceKeys.TscaForm.TITLE
    )
    let packingListForm = translate(
      Namespace.SBCI_INVOICE,
      SbciInvoiceKeys.PackingListForm.TITLE
    )
    let laceyActForm = translate(
      Namespace.SBCI_INVOICE,
      SbciInvoiceKeys.LaceyActForm.TITLE
    )

    let naftaForm = translate(
      Namespace.SBCI_INVOICE,
      SbciInvoiceKeys.NaftaForm.TITLE
    )

    return {
      bolForm,
      tscaForm,
      packingListForm,
      laceyActForm,
      naftaForm
    }
  }

  async function handleDownload({ formKey, url, prefix }) {
    try {
      setDownload({ form: formKey, loading: true })
      const config = { responseType: 'blob' } 

      await securedSendRequest.execute(
        'POST',
        url,
        invoiceData,
        (response) => {
          const blob = new Blob([response.data])
          const curDate = format(new Date(), 'yyyyMMddHHmmss')
          const a = document.createElement('a')

          a.href = window.URL.createObjectURL(blob)
          a.download = `${prefix}_${curDate}.pdf`
          a.click()
        },
        (error) => {
          console.error(error)
          showNotification('error', 'Download failed')
        },
        undefined,
        config,
        null
      )
    } catch (error) {
      console.log(error)
    } finally {
      setDownload({ form: null, loading: false })
    }
  }

  function isEmpty(value){

    if(value==null || value==undefined || value == ""){
      return true;
    }
    return false;
  }

  return (
    <CngSection title='Additional Form Information'>
      <Grid container spacing={2}>
        <Grid item xs='auto'>
          <QuickExportButton
            disabled={download.loading || isEmpty(invoiceData.bolForm) || isEmpty(invoiceData.bolForm.id) || 
              (
                isEmpty(invoiceData.bolForm.containerNo) &&
                isEmpty(invoiceData.bolForm.freightCharges) &&
                isEmpty(invoiceData.bolForm.placeOfLading) &&
                isEmpty(invoiceData.bolForm.deliveryInstructions) &&
                isEmpty(invoiceData.bolForm.codAmount) &&
                isEmpty(invoiceData.bolForm.currency) &&
                isEmpty(invoiceData.bolForm.shipmentDeclareValue) &&
                isEmpty(invoiceData.bolForm.releaseValue) &&
                isEmpty(invoiceData.bolForm.chargeTo) &&
                isEmpty(invoiceData.bolForm.totShpmntCubicFt) &&
                isEmpty(invoiceData.bolForm.freightClass)
              )
            }
            loading={download.loading && download.form === 'bol'}
            label={translatedTextsObject.bolForm}
            onClick={() =>
              handleDownload({
                formKey: 'bol',
                url: SbciInvoiceApiUrls.PRINT_BOL,
                prefix: 'SBCI_BOL'
              })
            }
          />
        </Grid>
        <Grid item xs='auto'>
          <QuickExportButton
            disabled={download.loading || isEmpty(invoiceData.tscaForm) || isEmpty(invoiceData.tscaForm.id) ||
              (
                isEmpty(invoiceData.tscaForm.tscaDate) &&
                isEmpty(invoiceData.tscaForm.tscaTitle) &&
                isEmpty(invoiceData.tscaForm.phone) &&
                isEmpty(invoiceData.tscaForm.companyName) &&
                isEmpty(invoiceData.tscaForm.address1) &&
                isEmpty(invoiceData.tscaForm.address2) &&
                isEmpty(invoiceData.tscaForm.citystatezip) &&
                isEmpty(invoiceData.tscaForm.tscaCertChoice) && 
                isEmpty(invoiceData.tscaForm.researchCert) && 
                (invoiceData.tscaForm.tscaDetails==null || (invoiceData.tscaForm.tscaDetails!=null && invoiceData.tscaForm.tscaDetails.length==0))
              )
            }
            loading={download.loading && download.form === 'tsca'}
            label={translatedTextsObject.tscaForm}
            onClick={() =>
              handleDownload({
                formKey: 'tsca',
                url: SbciInvoiceApiUrls.PRINT_TSCA,
                prefix: 'SBCI_TSCA'
              })
            }
          />
        </Grid>
        <Grid item xs='auto'>
            <QuickExportButton
              disabled={download.loading || isEmpty(invoiceData.naftaForm) || isEmpty(invoiceData.naftaForm.id) ||
                (
                  isEmpty(invoiceData.naftaForm.dateFrom) &&
                  isEmpty(invoiceData.naftaForm.dateTo) &&
                  isEmpty(invoiceData.naftaForm.company) &&
                  isEmpty(invoiceData.naftaForm.naftaTitle) &&
                  isEmpty(invoiceData.naftaForm.naftaDate) &&
                  isEmpty(invoiceData.naftaForm.partyName) &&
                  isEmpty(invoiceData.naftaForm.teleNo) &&
                  isEmpty(invoiceData.naftaForm.contactFax) &&
                  isEmpty(invoiceData.naftaForm.email) &&
                  isEmpty(invoiceData.naftaForm.certifierType)
                )
              }
              loading={download.loading && download.form === 'naftaForm'}
              label={translatedTextsObject.naftaForm}
              onClick={() =>
                handleDownload({
                  formKey: 'nafta',
                  url: SbciInvoiceApiUrls.PRINT_USMCA_CUSMA,
                  prefix: 'SBCI_USMCA'
                })
              }
            />
          </Grid>
        <Grid item xs='auto'>
          <QuickExportButton
            disabled={download.loading || isEmpty(invoiceData.packingListForm) || isEmpty(invoiceData.packingListForm.id) ||
              (
                isEmpty(invoiceData.packingListForm.otherRefNo) &&
                isEmpty(invoiceData.packingListForm.responsibleForCustoms) &&
                isEmpty(invoiceData.packingListForm.instructionsToBroker) &&
                isEmpty(invoiceData.packingListForm.containerized) &&
                isEmpty(invoiceData.packingListForm.flightDetails) &&
                isEmpty(invoiceData.packingListForm.specialInstructions) &&
                isEmpty(invoiceData.packingListForm.placeOfDelivery) &&
                isEmpty(invoiceData.packingListForm.portOfLoading) &&
                isEmpty(invoiceData.packingListForm.billChargesTo) &&
                isEmpty(invoiceData.packingListForm.dateShipped)
              )
            }
            loading={download.loading && download.form === 'packingList'}
            label={translatedTextsObject.packingListForm}
            onClick={() =>
              handleDownload({
                formKey: 'packingList',
                url: SbciInvoiceApiUrls.PRINT_PL,
                prefix: 'SBCI_PL_'
              })
            }
          />
        </Grid>
        <Grid item xs='auto'>
          <QuickExportButton
            disabled={download.loading || isEmpty(invoiceData.laceyActForm) || isEmpty(invoiceData.laceyActForm.id) ||
              (
               isEmpty(invoiceData.laceyActForm.containerNo) &&
               isEmpty(invoiceData.laceyActForm.printName) &&
               isEmpty(invoiceData.laceyActForm.descOfMerchandise) &&
               isEmpty(invoiceData.laceyActForm.laceyDate) &&
               isEmpty(invoiceData.laceyActForm.estimatedArrivalDate) &&
               (invoiceData.laceyActForm.laceyActDetails==null || (invoiceData.laceyActForm.laceyActDetails!=null &&invoiceData.laceyActForm.laceyActDetails.length==0))
              )
            }
            loading={download.loading && download.form === 'laceyAct'}
            label={translatedTextsObject.laceyActForm}
            onClick={() =>
              handleDownload({
                formKey: 'laceyAct',
                url: SbciInvoiceApiUrls.PRINT_LACEYACT,
                prefix: 'SBCI_LACEY_ACT'
              })
            }
          />
        </Grid>
      </Grid>
    </CngSection>
  )
}

export default AdditionalFormInfoSection
